import processGetItemResponse from '../actions/processGetItemResponse';
import RequestStatus from '../store/schema/RequestStatus';
import { mailStore } from 'owa-mail-store';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { mutator } from 'satcheljs';

export default mutator(processGetItemResponse, actionMessage => {
    const { itemId, conflictMeetings, adjacentMeetings, meetingRequestViewState } = actionMessage;

    const item: CalendarItem = mailStore.items.get(itemId);
    if (!item) {
        // No-op if the item has been deleted from item cache
        return;
    }

    // Updating the local store calendar item.
    // We need to convert undefined conflict/adjacent meetings to an object with empty array, to distinguish between below two scenarios.
    // - getItem hasn't been issued to fetch the conflict info
    // - getItem has been issued and there is no conflict
    item.ConflictingMeetings = conflictMeetings || { Items: [] };
    item.AdjacentMeetings = adjacentMeetings || { Items: [] };

    meetingRequestViewState.conflictsRequestStatus = RequestStatus.Complete;
});
